<template>
  <div class="dashboard">
    <MapViewPointCluster />
    <!-- <MapViewStandard /> -->
  </div>
</template>

<script>
// import MapViewStandard from '@/components-2025/MapViewStandard.vue';
import MapViewPointCluster from '@/components-2025/MapViewPointCluster.vue';

export default {
  name: 'Dashboard',
  components: {
    MapViewPointCluster,
  }
}
</script>
